import React from "react";
import { ArrowUpOutlined, AppstoreOutlined, SmileOutlined, EnvironmentOutlined, CarOutlined, QuestionCircleOutlined, UserSwitchOutlined, TeamOutlined, FlagOutlined, CoffeeOutlined, BankOutlined } from "@ant-design/icons";
import GamePicker from "./GamePicker";

export const twoPlayerGames = [
    {
        to: "/higherOrLower",
        labelKey: "games.names.higherOrLower",
        icon: <ArrowUpOutlined />,
    },
    {
        to: "/beerpong",
        labelKey: "games.names.beerpong",
        icon: <AppstoreOutlined />,
    },
    {
        to: "/laughfool",
        labelKey: "games.names.laughfools",
        icon: <SmileOutlined />,
    },
    {
        to: "/holzfaellern",
        labelKey: "games.names.holzfaellern",
        icon: <EnvironmentOutlined />,
    },
    {
        to: "/dontDrinkAndDrive",
        labelKey: "games.names.dontDrinkAndDrive",
        icon: <CarOutlined />,
    },
    {
        to: "/quizzler",
        labelKey: "games.names.quizzduell",
        icon: <QuestionCircleOutlined />,
    },
    {
        to: "/rideTheBus",
        labelKey: "games.names.busfahren",
        icon: <UserSwitchOutlined />,
    },
    {
        to: "/hawaii",
        labelKey: "games.names.hawaii",
        icon: <AppstoreOutlined />,
    },
    {
        to: "/horseRaising",
        labelKey: "games.names.horseRaising",
        icon: <FlagOutlined  />,
    },
    {
        to: "/iti",
        labelKey: "games.names.iti",
        icon: <CoffeeOutlined />,
    },
    {
        to: "/itiEatMyAss",
        labelKey: "games.names.itiPussy",
        icon: <CoffeeOutlined />,
    },
    {
        to: "/greekTempel",
        labelKey: "games.names.greekTemple",
        icon: <BankOutlined />,
    },
];

const SaufTwo: React.FC = () => (
    <GamePicker games={twoPlayerGames} titleKey="pages.saufTwo.title" icon={<TeamOutlined />} maxWidth={650} columns={{ sm: 12, md: 8 }} bordered={false} playerCountKey="pages.drinkhelper.players.double" />
);

export default SaufTwo;
